import { render } from "./HomeFrontBis.vue?vue&type=template&id=98188aea&scoped=true"
import script from "./HomeFrontBis.vue?vue&type=script&lang=js"
export * from "./HomeFrontBis.vue?vue&type=script&lang=js"

import "./HomeFrontBis.vue?vue&type=style&index=0&id=98188aea&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98188aea"]])

export default __exports__